import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const RTL_LANGUAGES = new Set(['ar', 'fa', 'he']);

const getLanguageBaseCode = (language) => {
  return language.toLowerCase().split('-')[0];
};

const HelmetConfig = () => {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage || i18n.language || 'en';
  const languageBaseCode = getLanguageBaseCode(language);
  const direction = RTL_LANGUAGES.has(languageBaseCode) ? 'rtl' : 'ltr';

  return (
    <Helmet>
      <html lang={language} dir={direction} />
    </Helmet>
  );
};

export default HelmetConfig;
